var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "FancySelect",
    _vm._g(
      {
        staticStyle: { "min-width": "150px" },
        attrs: {
          placeholder: "Batch Lookup",
          options: _vm.batches,
          loading: _vm.loading,
          value: _vm.value,
          disabled: _vm.disabled
        },
        on: { search: event => _vm.onSearch(event) },
        scopedSlots: _vm._u([
          {
            key: "option",
            fn: function(batch) {
              return [
                _vm._v(" " + _vm._s(batch.label) + " "),
                batch.date
                  ? [
                      _c("br"),
                      _c("layoutText", { staticClass: "date-row" }, [
                        _vm._v(_vm._s(batch.date))
                      ])
                    ]
                  : _vm._e()
              ]
            }
          }
        ])
      },
      _vm.$listeners
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }